import { Box, Typography } from "@mui/material";
import SubmitButton from "../UI/SubmitButton";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import FileOpenIcon from '@mui/icons-material/FileOpen';
import { useTranslation } from "react-i18next";

const monthsArmenian = [
    "Հունվար", "Փետրվար", "Մարտ", "Ապրիլ", "Մայիս", "Հունիս",
    "Հուլիս", "Օգոստոս", "Սեպտեմբեր", "Հոկտեմբեր", "Նոյեմբեր", "Դեկտեմբեր"
];


function formatGetterDate(dateString) {
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.getMonth();
    const monthName = monthsArmenian[month];
    return `${day} ${monthName}`;
}

function WarehouseDocumentItem({ document }) {

    const {t} = useTranslation()

    const {
        status,
        unscheduled
    } = document

    const {
        role
    } = useSelector(store => store.authorization)

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '15px',
                gap: 3,
                borderRadius: '16px',
                border: '0.5px solid #f1f1f1',
            }}
            key={document.id}>
            <Typography variant="h6">
                {formatGetterDate(document.detail_date)}
            </Typography>
            <Box sx={{
                display: 'flex',
                gap: '15px',
                alignItems: 'center'
            }}>
                <Typography>{document.author?.username} </Typography>
            </Box>
            <Link to={'/warehouse/document/' + document.id}>
                <SubmitButton endIcon={<FileOpenIcon />}>{t('button.open')}</SubmitButton>
            </Link>
        </Box>
    )
}


export default WarehouseDocumentItem